
import React from 'react';

const AuthHeader: React.FC = () => {
  return (
    <div className="text-center mb-8">
      <h1 className="text-3xl font-bold">TeamHub</h1>
      <p className="text-muted-foreground mt-2">Microsoft 365 Governance Platform</p>
    </div>
  );
};

export default AuthHeader;
